import state from "./moduleUsersManagementState";
import mutations from "./moduleUsersManagementMutations";
import actions from "./moduleUsersManagementActions";

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
